module.exports = __webpack_public_path__ + "static/img/error.4c0f07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/error.png
// module id = FF+y
// module chunks = 1